<template>
  <div>
    <div class="d-flex button-group justify-content-end">
      <b-btn variant="outline-success" @click="saveProduct">
        {{ $t('buttons.common.save')}}
      </b-btn>
    </div>
    <div class="filter-form">
      <b-row>
        <b-col>
          <label>{{$t('labels.common.group')}}</label>
          <multiselect v-model="productData.group" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.group"
                       :close-on-select="true" :class="{ required: !productData.group}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
          <multiselect v-model="productData.tree" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.tree"
                       :close-on-select="true" :class="{ required: !productData.tree}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.thickness')}}</label>
          <input class="form-control" v-model="productData.thickness" :class="{ required: !productData.thickness}">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.profile')}}</label>
          <multiselect v-model="productData.profile" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.profile"
                       :close-on-select="true" :class="{ required: !productData.profile}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.humidity')}}</label>
          <input class="form-control" v-model="productData.humidity" :class="{ required: !productData.humidity}">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.width')}}</label>
          <input class="form-control" v-model="productData.width" :class="{ required: !productData.width}">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
          <multiselect v-model="productData.quality" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.quality"
                       :close-on-select="true" :class="{ required: !productData.quality}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.impr')}}</label>
          <multiselect v-model="productData.impr" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.impr"
                       :close-on-select="true" :class="{ required: !productData.impr}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.length')}}</label>
          <input class="form-control" v-model="productData.length" :class="{ required: !productData.length}">
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="4" cols="4">
          <label>{{$t('labels.common.certificate')}}</label>
          <multiselect v-model="productData.wood_certificate" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="optionsData.wood_certificate"
                       :close-on-select="true" :class="{ required: !productData.wood_certificate}"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{productData.name}}</label>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import { handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        optionsData: {
          group: [],
          wood_certificate: [],
          impr: [],
          product_desc: [],
          profile: [],
          quality: [],
          tree: []
        },
        productData: {
          name: '',
          wood_certificate: null,
          impr: null,
          profile: null,
          quality: null,
          tree: null,
          group: null,
          humidity: '',
          thickness: '',
          width: '',
          length: ''
        }
      }
    },
    methods: {
      saveProduct() {
        const savedData = {
          group: this.productData.group && this.productData.group.id,
          wood_certificate: this.productData.wood_certificate && this.productData.wood_certificate.id,
          impr: this.productData.impr && this.productData.impr.id,
          profile: this.productData.profile && this.productData.profile.id,
          quality: this.productData.quality && this.productData.quality.id,
          tree: this.productData.tree && this.productData.tree.id,
          width: this.productData.width,
          length: this.productData.length,
          humidity: this.productData.humidity,
          thickness: this.productData.thickness
        };
        this.$http.post(`woodware/create_or_get_exists_product/`, savedData).then(handlerResponse).then((response) => {
          this.$router.push({path: `/product/${response.id}`});
        }).catch((error) => {
          notificationsRenderer(error.data, 'error');
        });
      },
      loadProductData() {
        const params = {for_vue: true};
        this.$http.get(`woodware/products/${this.param}/`, {params}).then(handlerResponse).then((response) => {
          this.productData = {...this.productData, ...response};
        });
      },
      fetchInitializeData() {
        this.$http.get(`woodware/list/data_for_product_selects/`).then(handlerResponse).then((response) => {
          this.optionsData = {...response};
          if (!this.isNewProduct) {
            this.loadProductData();
          }
        });
      }
    },
    computed: {
      param() {
        return this.$route.params.id;
      },
      isNewProduct() {
        return this.param === 'new';
      },
    },
    created() {
      this.fetchInitializeData();
    },
    beforeRouteUpdate(to, from, next) {
      next();
      this.fetchInitializeData();
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/general/products/Product.vue